import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';

import { SubTitle } from '../../../styles';
import { Nit } from '../../../components/Fields/Nit';
import { EditableField } from '../../../components/EditableField';
import { Address, City, District, Plan } from '../../../components';
import { useGetContractPlans } from '@/components/Settings/ContractPlans/hooks/index';

export function Informations() {
	const { data } = useGetContractPlans();

	return (
		<Row gutter={[0, 25]}>
			<Col span={24}>
				<EditableField name="name" title="Corporate name" errorMessage="Enter a corporate name" required />
			</Col>
			<Col span={24}>
				<Row gutter={[0, 5]}>
					<Col span={24}>
						<SubTitle>{I18n.get('Information')}</SubTitle>
					</Col>
					<Col>
						<Row gutter={[40, 20]}>
							<Col span={24}>
								<Address name="address" required />
							</Col>
							<Col span={12}>
								<City name="city" required />
							</Col>
							<Col span={12}>
								<District name="district" required />
							</Col>
							<Col span={12}>
								<Plan name="plan" options={data} required />
							</Col>
							<Col span={12}>
								<Nit name="nit" required />
							</Col>
						</Row>
					</Col>
				</Row>
			</Col>
		</Row>
	);
}
